import { Grid, Stack, Text, Title } from '@mantine/core';
import moment from 'moment';

import { Discrepancy } from '@e-origin/shared';

interface DiscrepanciesSectionProps {
  discrepancies: Discrepancy[];
}

export const DiscrepanciesSection: React.FC<DiscrepanciesSectionProps> = ({ discrepancies }) => {
  return (
    <Stack mb="md">
      <Title order={5} fw={600}>
        Discrepancies
      </Title>
      {discrepancies.map((item, idx) => (
        <Grid key={idx}>
          <Grid.Col span={3}>
            <Stack gap="xs">
              <Text c="gray" size="sm">
                Notification date
              </Text>
              <Text fw={500}>{moment(item.date).format('YYYY-MM-DD')}</Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap="xs">
              <Text c="gray" size="sm">
                Notification type
              </Text>
              <Text fw={500}>{item.text}</Text>
            </Stack>
          </Grid.Col>
        </Grid>
      ))}
    </Stack>
  );
};
